import { PageHeader } from "@/components/common/ui-kit";
import { ContractsList } from "@/components/contracts/ContractsList";

export default function ContractsPage() {
  return (
    <div data-testid="contracts-page">
      <PageHeader overline="Asset & Contratti" title="Contratti" description="Rapporti continuativi con i clienti: canoni, coperture, manutenzioni, rinnovi e collegamenti a offerte, ordini, asset e licenze." />
      <ContractsList showKpi />
    </div>
  );
}
